import * as React from 'react'
import { useDispatch } from 'react-redux'

import Popup from '../../../ui/popup'
import Button from '../../../ui/button'
import TextAreaField from '../../../form/TextAreaField'

import { Formik, Form, Field, FieldProps, FormikProps } from 'formik'

import { SendGuestbookMessage } from '../../../../store/profile/profileTypings'
import { ProfileShort } from '../../../../store/commonTypes'

import { postGuestbookMessage } from '../../../../store/profile/profileSlice'
import { useTranslation } from 'react-i18next'

interface Props {
    user: ProfileShort
    onClose: () => void
}

const GuestbookPopup: React.FunctionComponent<Props> = ({ user, onClose }: Props) => {
    const [t] = useTranslation()
    const dispatch = useDispatch()

    return (
        <Popup
            title={`${t('Add message to Guestbook of')} ${user.nick}`}
            onClose={onClose}
            classname="vertical"
            profile={true}
        >
            <Formik
                initialValues={{ message: '', user_id: user.id }}
                onSubmit={(values: SendGuestbookMessage) => {
                    dispatch(postGuestbookMessage(values))
                    onClose()
                }}
            >
                {(props: FormikProps<SendGuestbookMessage>) => {
                    const { submitForm } = props
                    return (
                        <Form className="form">
                            <Field name="message">
                                {({ field, meta, form }: FieldProps) => (
                                    <TextAreaField form={form} field={field} error={meta.error} placeholder="Message" />
                                )}
                            </Field>
                            <div className="popup__buttons">
                                <Button label="Send" type="button" onClick={submitForm} />
                                <Button label="Cancel" secondary onClick={onClose} />
                            </div>
                        </Form>
                    )
                }}
            </Formik>
        </Popup>
    )
}

export default GuestbookPopup
